export default __webpack_public_path__ + "static/Plots0006-4af834e6ed4ede3006350e04dba6e025.jpg";